<template>
  <Head title="Tambah Dokumen" />
  <Container>
    <template #header>
      <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
    </template>
    <template #default>
      <div class="container px-4 mx-auto">
        <Breadcrumbs
          :breadcrumbs="[
            { name: 'Dashboard', href: route('dashboard') },
            { name: `Kinerja Program Studi`, href: route('kinerja.index') },
            {
              name: `${instrumens.data[0].instrumen}`,
              href: route('kinerja.adddocument', instrumens.data[0].slugid),
            },
          ]"
        />
        <div
          class="flex flex-col items-start gap-4 md:flex-row md:items-center md:justify-between"
        >
          <div>
            <h1 class="text-2xl font-bold text-gray-900 sm:text-3xl">
              {{ instrumens.data[0].instrumen }}
            </h1>
          </div>
          <div class="flex items-center gap-4">
            <p class="text-sm text-gray-500">
              Tambah Dokumen Kinerja /
              {{ instrumens.data[0]?.akreditasi?.akreditasi || "N/A" }}
            </p>
          </div>
        </div>

        <div class="col-span-1 p-4 lg:col-span-2">
          <div class="grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-8">
            <div class="h-auto">
              <FormAdd :instrumen="instrumens" :program="programs" />
            </div>
            <div class="h-auto rounded-lg lg:col-span-2">
              <div class="overflow-hidden bg-white border rounded-lg shadow">
                <div
                  class="px-4 py-2 overflow-hidden text-sm font-medium text-gray-900 border-b bg-gray-50"
                >
                  <h1>{{ instrumens.data[0].instrumen }}</h1>
                </div>
                <div class="p-4 overflow-x-auto">
                  <table class="w-full table-auto">
                    <thead>
                      <tr
                        class="text-xs font-medium text-left text-gray-500 uppercase"
                      >
                        <th class="px-4 py-2">No</th>
                        <th class="px-4 py-2">Nama Dokumen</th>
                        <th class="px-4 py-2">Tipe Dokumen</th>
                        <th class="px-4 py-2">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(dokumen, index) in files.data"
                        :key="index"
                        class="border-b hover:bg-gray-50"
                      >
                        <td
                          class="px-4 py-2 text-sm text-gray-900 whitespace-nowrap"
                        >
                          {{ index + 1 }}.
                        </td>
                        <td
                          class="px-4 py-2 text-sm text-gray-900 whitespace-nowrap"
                        >
                          {{ dokumen.nama_dok }}
                        </td>
                        <td
                          class="px-4 py-2 text-sm text-gray-900 whitespace-nowrap"
                        >
                          {{ dokumen.jenisdokumen.nama }}
                        </td>
                        <td
                          class="px-4 py-2 text-sm text-gray-900 whitespace-nowrap"
                        >
                          <Link
                            :href="route('kinerja.show', dokumen.iddok)"
                            class="px-2 py-1 text-xs font-semibold text-white bg-blue-500 rounded hover:bg-blue-600"
                          >
                            Lihat
                          </Link>
                          <!-- <button
                    @click="editFile(dokumen.id)"
                    class="px-2 py-1 ml-2 text-xs font-semibold text-white bg-green-500 rounded hover:bg-green-600"
                  >
                    File
                  </button>
                  <a
                    :href="`/download/${dokumen.id}`"
                    class="px-2 py-1 ml-2 text-xs font-semibold text-white bg-red-500 rounded hover:bg-red-600"
                    >Download</a
                  > -->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  class="px-4 py-2 text-sm font-medium text-gray-900 border-t bg-gray-50"
                >
                  <p class="text-sm text-gray-500">
                    Menampilkan
                    <span class="font-semibold text-gray-900">{{
                      files.data.length
                    }}</span>
                    dari
                    <span class="font-semibold text-gray-900">{{
                      files.total
                    }}</span>
                    data dokumen.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Container>
</template>

<script setup>
import { defineProps, watch, ref } from "vue";
import { Head } from "@inertiajs/vue3";
import Container from "@/Layouts/Container.vue";
import Header from "@/Components/Header.vue";
import FormAdd from "@/Components/Kinerja/FormAddDokumen.vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";

const props = defineProps({
  instrumens: {
    type: Object,
    required: true,
  },
  files: {
    type: Object,
    required: true,
  },
  programs: {
    type: Object,
    required: true,
  },
});
const isModalOpen = ref(false);
const isModalFile = ref(false);
const viewdokumen = ref(null);
const selectedJenis = ref(null);
const selectedProdi = ref(null);

const editDokumen = async (iddok) => {
  try {
    const response = await fetch(`/viewdockinerja/${iddok}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    viewdokumen.value = data.dokumen;
    selectedJenis.value = data.jenis;
    selectedProdi.value = data.prodis;
    isModalOpen.value = true;
  } catch (error) {
    console.error("Error fetching data:", error.message);
  }
};
const editFile = async (iddok) => {
  try {
    const response = await fetch(`/viewdockinerja/${iddok}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    viewdokumen.value = data.dokumen;
    selectedJenis.value = data.jenis;
    isModalFile.value = true;
  } catch (error) {
    console.error("Error fetching data:", error.message);
  }
};
// Check if file is an image
function isImage(filePath) {
  return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filePath);
}

// Check if file is a PDF
function isPdf(filePath) {
  return /\.pdf$/i.test(filePath);
}
</script>
